{
  "Sidebar": {
    "badges": {
      "beta": "بيتا"
    },
    "guest": {
      "title": "يُحفظ عملك مؤقتًا فقط",
      "description": "بصفتك ضيفًا، لن تتمكن من الوصول إلى امتحاناتك ومحادثاتك وملفاتك بعد إغلاق علامة التبويب هذه؛ وتُحذف في موعد أقصاه 24 ساعة بعد آخر نشاط لك. سجّل الدخول مجانًا لحفظها بشكل دائم.",
      "loginButton": "سجّل الدخول الآن"
    },
    "actions": {
      "newExamTitle": "إنشاء امتحان جديد",
      "creating": "جاري الإنشاء...",
      "newExam": "امتحان جديد"
    },
    "examList": {
      "title": "امتحاناتي",
      "noExams": "لم يتم العثور على امتحانات.",
      "unnamed": "بلا اسم",
      "unnamedExam": "امتحان بلا اسم",
      "loadOlder": "تحميل الاختبارات الأقدم"
    },
    "examMenu": {
      "edit": "تعديل",
      "addToClass": "إضافة إلى الصف",
      "delete": "حذف"
    },
    "bottomNav": {
      "profile": "الملف الشخصي",
      "settings": "الإعدادات",
      "feedback": "إرسال الملاحظات"
    },
    "dialogs": {
      "renameTitle": "تعديل الامتحان",
      "groupTitle": "تجميع الامتحان",
      "renameDesc": "تعديل معلومات الامتحان.",
      "groupDesc": "اختر صفًا أو مجموعة لهذا الامتحان.",
      "fields": {
        "name": "الاسم",
        "subject": "المادة",
        "topic": "الموضوع",
        "class": "الصف",
        "placeholderSelect": "الرجاء الاختيار..."
      },
      "save": "حفظ"
    },
    "alerts": {
      "saveFailed": "فشل الحفظ"
    },
    "deleteDialog": {
      "title": "حذف الامتحان؟",
      "body": "سيتم حذف الامتحان نهائيًا مع المحادثة وجميع التسليمات والملفات.",
      "keepReleases": "الاحتفاظ بالنتائج المنشورة للطلاب",
      "keepReleasesDesc_one": "سيظل طالب واحد يرى نتيجته. إذا ألغيت التحديد، فسيتم حذفها أيضًا.",
      "keepReleasesDesc_other": "سيظل {{count}} من الطلاب يرون نتائجهم. إذا ألغيت التحديد، فسيتم حذف هذه النتائج أيضًا.",
      "keepReleasesDescUnknown": "تظل جميع النتائج المنشورة مرئية للطلاب. إذا ألغيت التحديد، فسيتم حذفها أيضًا.",
      "cancel": "إلغاء",
      "confirm": "حذف"
    }
  },
  "Settings": {
    "title": "الإعدادات",
    "soon": "قريبًا",
    "DisplayAndLanguage": {
      "title": "المظهر واللغة",
      "languageLabel": "اللغة",
      "languageDesc": "اختر لغة واجهة المستخدم.",
      "themeLabel": "المظهر",
      "themeDesc": "التبديل بين الوضعين الفاتح والداكن."
    },
    "AI": {
      "title": "الذكاء الاصطناعي والتقييم",
      "strictnessLabel": "عدم يقين الذكاء الاصطناعي",
      "strictnessDesc": "يحدد مستوى ثقة الذكاء الاصطناعي الذي تكون عنده المراجعة اليدوية إلزامية.",
      "strictnessWarning": "تحذير: مع \"الاستقلالية العالية\"، تتدخل يدويًا فقط عندما يكون الذكاء الاصطناعي غير متيقن بشكل كبير...",
      "gradingKindnessLabel": "صرامة التقييم",
      "gradingKindnessDesc": "يحدد مدى صرامة تطبيق الذكاء الاصطناعي لمخطط الدرجات. المتساهل يفضل الطالب في الحالات الحدية؛ الصارم يتبع المخطط تمامًا.",
      "gradingKindnessOptions": {
        "lenient": "متساهل",
        "balanced": "متوازن",
        "strict": "صارم"
      }
    },
    "Notifications": {
      "title": "الإشعارات",
      "soon": "قريبًا",
      "emailLabel": "إشعارات البريد الإلكتروني",
      "emailDesc": "تلقي إشعارات البريد الإلكتروني حول الأحداث الهامة",
      "browserLabel": "إشعارات المتصفح",
      "browserDesc": "تلقي الإشعارات الفورية مباشرة في متصفحك"
    },
    "About": {
      "title": "حول Gradias",
      "landingPage": "زيارة gradias.ai",
      "support": "المساعدة والدعم",
      "imprint": "بيانات النشر القانونية",
      "privacy": "سياسة الخصوصية"
    },
    "Account": {
      "title": "البيانات والحساب",
      "exportLabel": "تصدير بياناتي",
      "exportDesc": "تنزيل جميع الامتحانات المرفوعة والنتائج كملف ZIP",
      "deleteLabel": "حذف الحساب",
      "deleteDesc": "حذف حسابك وبياناتك نهائيًا",
      "deleteDialogTitle": "حذف الحساب؟",
      "deleteDialogBody": "سنرسل رابط تأكيد إلى بريدك الإلكتروني. لا يُحذف حسابك إلا عبر هذا الرابط، مع امتحاناتك التدريبية ومحادثاتك وملفاتك وعضوياتك في الصفوف والنتائج المنشورة لك. الأعمال التي سلمتها في امتحان أحد المعلمين تبقى لدى المعلم.",
      "deleteDialogSent": "أرسلنا إليك رابطًا. افتحه خلال ساعة واحدة لتأكيد الحذف.",
      "deleteDialogError": "حدثت مشكلة. يرجى المحاولة مرة أخرى لاحقًا.",
      "deleteDialogCancel": "إلغاء",
      "deleteDialogConfirm": "إرسال رابط التأكيد",
      "deleteDialogClose": "إغلاق",
      "deleteDialogBodyTeacher": "سنرسل رابط تأكيد إلى بريدك الإلكتروني. لا يُحذف حسابك إلا عبر هذا الرابط، مع جميع صفوفك وامتحاناتك والتسليمات والمحادثات والملفات. سيفقد طلابك صفهم وجميع النتائج المنشورة لهم، وتبقى حساباتهم الخاصة. يرجى إبلاغهم مسبقًا.",
      "deleteDialogImpactTeacher": "الصفوف: {{classes}} · الامتحانات: {{exams}} · الطلاب المتأثرون: {{students}}",
      "deleteDialogBlockedAdmin": "لا يمكن حذف حسابات المسؤولين من هنا. يجب أولًا إزالة الحساب من ADMIN_USER_IDS.",
      "deleteDialogBlockedImpersonating": "لا يمكن حذف هذا الحساب أثناء تسجيل دخولك كمستخدم آخر."
    }
  },
  "Profile": {
    "title": "الملف الشخصي",
    "actions": {
      "cancel": "إلغاء",
      "save": "حفظ",
      "edit": "تعديل"
    },
    "alerts": {
      "saveError": "تعذر حفظ الملف الشخصي.",
      "generalError": "حدث خطأ ما."
    },
    "personal": {
      "firstName": "الاسم الأول",
      "lastName": "اسم العائلة",
      "name": "الاسم",
      "school": "المدرسة",
      "noSchool": "لم يتم تحديد مدرسة",
      "email": "البريد الإلكتروني",
      "emailHint": "لا يمكن تغيير البريد الإلكتروني هنا.",
      "defaultUser": "مستخدم",
      "role": {
        "teacher": "معلم",
        "student": "طالب"
      }
    },
    "teaching": {
      "subjects": "موادي الدراسية",
      "noSubjects": "لم يتم تحديد مواد دراسية"
    },
    "rules": {
      "title": "القواعد والتفضيلات",
      "description": "التفضيلات المحفوظة التي يلتزم بها المساعد - عند الدردشة، التقييم، وعند إنشاء الحلول النموذجية ومعايير التقييم. يمكنك تعديلها هنا بنفسك، ولكن يمكن للمساعد أيضًا تعديلها مباشرة في الدردشة بناءً على طلبك.",
      "general": "عام",
      "empty": "لم يتم حفظ أي قواعد بعد.",
      "addRule": "إضافة قاعدة",
      "removeRule": "إزالة قاعدة",
      "limitReached": "تم الوصول إلى الحد الأقصى",
      "limitHint": "الحد الأقصى {{max}} قواعد لكل فئة",
      "placeholder": "وصف القاعدة ...",
      "categories": {
        "chat_and_workflow": "الدردشة وسير العمل",
        "grading_and_feedback": "التقييم والملاحظات",
        "master_solution_design": "الحلول النموذجية",
        "grading_scheme_creation": "معايير التقييم"
      },
      "categoryDescs": {
        "chat_and_workflow": "كيف يجيب المساعد في الدردشة ويتحكم في سير العمل",
        "grading_and_feedback": "كيف يتم تقييم الإجابات وصياغة الملاحظات",
        "master_solution_design": "كيف يتم إنشاء الحلول النموذجية",
        "grading_scheme_creation": "كيف يتم بناء معايير التقييم"
      },
      "grammar": {
        "alwaysUseFi": "استخدام مؤشر الأخطاء (FI) دائمًا",
        "alwaysUseFiDesc": "يستخدم مؤشر الأخطاء افتراضيًا بدلاً من أي قواعد لغوية مكتشفة من مخطط تقييم مرفوع. يمكن تجاوز هذا لكل اختبار على حدة.",
        "languageUseRegradeWordCutoff": "إعادة تقييم الأداء اللغوي تلقائيًا بدءًا من (كلمات)",
        "languageUseRegradeWordCutoffDesc": "عند تعديل إجابة الطالب، تتم إعادة تقييم الأداء اللغوي للمجموعة المتأثرة تلقائيًا بمجرد تغيير هذا العدد من الكلمات على الأقل (تُجمع عدة تعديلات صغيرة معًا).",
        "contentRegradeWordCutoff": "إعادة تقييم المحتوى تلقائيًا بدءًا من (كلمات)",
        "contentRegradeWordCutoffDesc": "0 = دائمًا (الافتراضي) — تتم إعادة تقييم المحتوى فورًا عند أي تغيير في النص. القيمة الأعلى تتخطى إعادة التقييم التلقائي للتعديلات الصغيرة جدًا."
      }
    },
    "security": {
      "title": "الحساب والأمان",
      "changePassword": "تغيير كلمة المرور",
      "changePasswordDesc": "إدارة أمان حسابك",
      "changePasswordSent": "أرسلنا إليك رابطًا عبر البريد الإلكتروني لتغيير كلمة المرور.",
      "changePasswordError": "حدثت مشكلة. يرجى المحاولة مرة أخرى لاحقًا.",
      "changePasswordConfirmTitle": "تغيير كلمة المرور؟",
      "changePasswordConfirmDesc": "سنرسل رابطًا إلى {{email}}. إذا استخدمته وعيّنت كلمة مرور جديدة، فسيتم تسجيل خروجك من جميع الأجهزة الأخرى.",
      "changePasswordSend": "إرسال الرابط",
      "changePasswordCancel": "إلغاء",
      "changePasswordClose": "إغلاق",
      "logout": "تسجيل الخروج",
      "logoutDesc": "تسجيل الخروج بأمان من هذا الجهاز"
    },
    "badges": {
      "soon": "قريبًا"
    }
  },
  "ClassInsights": {
    "overview": "نظرة عامة",
    "examCount": "الاختبارات",
    "subjectCount": "المواد",
    "gradedCount": "تم تصحيحها",
    "examListTitle": "الاختبارات في هذا الصف",
    "noExams": "لا توجد اختبارات في هذا الصف بعد.",
    "loading": "جارٍ تحميل الإحصاءات …",
    "statusGraded": "تم التصحيح",
    "statusInProgress": "قيد المعالجة",
    "unnamedExam": "اختبار بدون اسم",
    "unknownSubject": "مادة غير معروفة"
  },
  "Dashboard": {
    "guestMessage": "أنا gradi، مساعدك الذكي لتصحيح الامتحانات.",
    "greetings": {
      "opt1": "ما هي الامتحانات التي سنصححها اليوم؟",
      "opt2": "دعنا ننجز هذه الكومة من الامتحانات.",
      "opt3": "ما هو جدول أعمال اليوم؟",
      "opt4": "كيف يمكنني مساعدتك اليوم？",
      "opt5": "يسعدني وجودك هنا. بم نبدأ؟",
      "opt6": "دعنا نبدأ التصحيح!"
    },
    "studentGreetings": {
      "opt1": "ماذا سنتعلم اليوم؟",
      "opt2": "هيا نحل بعض أسئلة الامتحان!",
      "opt3": "ما هو جدول أعمال اليوم؟",
      "opt4": "كيف يمكنني مساعدتك اليوم؟",
      "opt5": "يسعدني وجودك هنا. بم نبدأ؟",
      "opt6": "هيا نبدأ!"
    },
    "fallbackGreeting": "ما هو جدول أعمال اليوم؟",
    "greetingPrefix": "مرحبًا",
    "inputPlaceholder": "اسأل سؤالاً...",
    "dropzoneText": "أفلت الملفات هنا",
    "actions": {
      "startGrading": {
        "label": "بدء تصحيح الامتحان",
        "prompt": "أريد بدء تصحيح امتحان جديد. يرجى توجيهي خطوة بخطوة خلال العملية من الرفع وحتى معايير التقييم."
      },
      "uploadExam": {
        "label": "رفع امتحاني",
        "prompt": "أريد رفع امتحان أنهيته بالفعل لكي تصححه لي. كيف نبدأ؟"
      },
      "createExam": {
        "label": "إنشاء امتحان تدريبي",
        "prompt": "أريد إنشاء امتحان تدريبي جديد. هل يمكنك مساعدتي في إعداده؟"
      },
      "howItWorks": {
        "label": "كيف يعمل gradias؟",
        "prompt": "يرجى شرح كيفية عمل gradias باختصار وإيجاز، وما هي الخطوات التي يجب أن أمر بها لتصحيح ناجح."
      },
      "sampleData": {
        "label": "الاختبار باستخدام بيانات تجريبية",
        "prompt": "أريد اختبار النظام، ولكن ليس لدي امتحانات خاصة بي حاليًا. كيف يمكنني الاختبار باستخدام امتحان تجريبي؟"
      },
      "taskTypes": {
        "label": "ما هي أنواع الأسئلة المتاحة؟",
        "prompt": "ما هي أنواع الأسئلة (مثل النصوص الحرة، الاختيار من متعدد، المعادلات الرياضية) التي يمكنك تصحيحها حاليًا؟"
      },
      "privacy": {
        "label": "حماية البيانات والأمان",
        "prompt": "كيف يتعامل gradias مع موضوع حماية البيانات؟ ماذا يحدث للامتحانات المرفوعة لطلابي؟"
      }
    },
    "alerts": {
      "uploadError": "خطأ أثناء رفع الملف",
      "noExamId": "لا يوجد examId"
    },
    "aria": {
      "uploadFiles": "رفع الملفات",
      "submit": "إرسال",
      "removeFile": "إزالة الملف"
    }
  },
  "ChatInput": {
    "statusLabels": {
      "allComplete": "اكتملت جميع الخطوات",
      "configRunning": "جاهز - مستعد للمتابعة",
      "readyForConfig": "جاهز للتكوين",
      "status": "الحالة",
      "progress": "التقدم",
      "inProgress": "جاري"
    },
    "steps": {
      "examCreator": {
        "label": "إنشاء امتحان",
        "phasePlan": "التخطيط للامتحان",
        "phaseMaterial": "إنشاء الأشكال",
        "phaseSource": "كتابة الأسئلة",
        "phaseRepair": "إنهاء المستند"
      },
      "upload": {
        "label": "رفع الملفات"
      },
      "studentAssignment": {
        "label": "تخصيص الطلاب",
        "activeWait": "في انتظار التأكيد",
        "activeAssign": "تعيين إجابات الطلاب"
      },
      "structure": {
        "label": "بنية الامتحان",
        "active": "يتم التعرف على الأسئلة"
      },
      "answers": {
        "label": "إجابات الطلاب",
        "active": "يتم معالجة الإجابات"
      },
      "masterSolution": {
        "label": "الحل النموذجي",
        "activeDetect": "يتم التعرف على الحل النموذجي",
        "activeCreate": "يتم إنشاء الحل النموذجي",
        "activeComplete": "يتم إكمال الحل النموذجي"
      },
      "gradingScheme": {
        "label": "معايير التقييم",
        "activeDetect": "يتم التعرف على معايير التقييم",
        "activeCreate": "يتم إنشاء معايير التقييم",
        "activeComplete": "يتم إكمال معايير التقييم"
      },
      "grading": {
        "label": "التصحيح",
        "active": "التصحيح جاري"
      },
      "summary": {
        "label": "ملخص النتائج"
      }
    },
    "badges": {
      "uncertainties": "الشكوك",
      "errorRegions": "المناطق الخاطئة",
      "errorSubmissions": "الإجابات الخاطئة",
      "documentEncrypted": "المستند مشفر"
    },
    "ui": {
      "showProgress": "إظهار تقدم التصحيح",
      "dropFilesHere": "أفلت الملفات هنا",
      "uploadFiles": "رفع الملفات",
      "waitUpload": "انتظر الرفع",
      "sendMessage": "إرسال رسالة",
      "privacyNotice": "متوافق بنسبة 100% مع اللائحة العامة لحماية البيانات (GDPR). لن تُستخدم بياناتك ومستندات الطلاب لتدريب الذكاء الاصطناعي.",
      "learnMore": "معرفة المزيد."
    },
    "alerts": {
      "uploadError": "خطأ أثناء رفع الملف",
      "noExamId": "لا يوجد examId"
    }
  },
  "TokenInput": {
    "placeholder": "اسأل سؤالاً..."
  },
  "Chat": {
    "auth": {
      "login": "تسجيل الدخول",
      "register": "التسجيل"
    },
    "loading": {
      "masterSolutions": "جاري تحميل الحلول النموذجية...",
      "examData": "جاري تحميل بيانات الامتحان والصور...",
      "extractingTasks": "جاري استخراج الأسئلة... {{finished}}/{{total}}",
      "splitThinkingMessage": "أقوم بتنظيم إجابات الطلاب",
      "structureThinkingMessage": "أقوم بالتعرف على بنية الامتحان",
      "examStructure": "جاري تحميل بنية الامتحان...",
      "pages": "جاري تحميل الصفحات...",
      "summary": "جاري تحميل الملخص..."
    },
    "alerts": {
      "errorOccurred": "عذرًا، حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا.",
      "reportsBlocked": "تقارير PDF لن تكون متاحة إلا بعد الموافقة على جميع الأسئلة الرئيسية أو إذا كانت ثقة الذكاء الاصطناعي أعلى من {{threshold}}%.",
      "noSubmissionsForReports": "لم يتم العثور على إجابات تحتوي على بيانات التقارير.",
      "reportsFailed": "تعذر إنشاء تقارير PDF. يرجى المحاولة مرة أخرى."
    },
    "sampleExamIntro": "أود تصحيح هذا الامتحان باستخدام المستندات التالية:\n{{lines}}",
    "canvasTitles": {
      "boundingbox": "تعديل مناطق الأسئلة",
      "msedit": "تعديل الحل النموذجي / معايير التقييم",
      "correction": "التصحيح",
      "summary": "ملخص التصحيح",
      "structureeditor": "تعديل بنية الامتحان",
      "submissioncheck": "التحقق من تخصيص الصفحات",
      "demoselector": "اختيار النسخة التجريبية",
      "examcreator": "إنشاء امتحان",
      "legal": "Legal Navigator (قانوني وتنظيمي)",
      "default": "عرض تفصيلي"
    },
    "legalNavigator": {
      "title": "محتوى خارجي: تطبيق ChatGPT من OpenAI",
      "notice": "Legal Navigator هو تطبيق ChatGPT من OpenAI. عند تحميله، يتم نقل عنوان IP الخاص بك وبيانات متصفحك إلى OpenAI، وربما إلى الولايات المتحدة أيضًا.",
      "noStudentData": "يرجى عدم إدخال أي بيانات شخصية عن الطلاب هناك.",
      "privacyLink": "سياسة الخصوصية لدى OpenAI",
      "load": "تحميل المحتوى"
    }
  },
  "Canvas": {
    "common": {
      "resize": "تعديل الحجم",
      "toSummaryTitle": "إلى الملخص",
      "backToSummary1": "العودة إلى",
      "backToSummary2": "الملخص",
      "restore": "استعادة",
      "fullscreen": "ملء الشاشة",
      "close": "إغلاق"
    },
    "grading": {
      "prevTask": "السؤال السابق",
      "nextTask": "السؤال التالي",
      "taskXofY": "السؤال {{current}} من أصل {{total}}",
      "taskName": "السؤال {{number}}",
      "nextUncertainty": "حالة عدم اليقين التالية ({{count}})",
      "uncertaintiesLeft": "تبقت {{count}} من حالات عدم اليقين",
      "backToSummary1": "العودة إلى",
      "backToSummary2": "الملخص",
      "submissionX": "الإجابة {{id}}",
      "pages": "الصفحات:",
      "pageX": "الصفحة {{page}}",
      "addBoundingBox": "إضافة مربع محيط جديد",
      "extractedText": "النص المستخرج",
      "verified": "مُحقَق",
      "consistencyAdjusted": "تم التعديل تلقائيًا لضمان الاتساق مع الإجابات الأخرى",
      "bboxConfidence": "ثقة المربع المحيط: {{conf}}%",
      "review": "مراجعة",
      "noTextExtracted": "لم يتم استخراج أي نص.",
      "imageContent": "صورة (لا يوجد تعرّف على النص) - سيتم استخدام جزء الصورة الذي تم التعرف عليه مباشرة لمزيد من المعالجة",
      "aiGrading": "تقييم الذكاء الاصطناعي",
      "pts": "نقطة",
      "points": "النقاط:",
      "noGradingYet": "لا يوجد تقييم متاح بعد.",
      "gradingScheme": "معايير التقييم",
      "expand": "توسيع",
      "collapse": "طي",
      "maxPoints": "الحد الأقصى للنقاط: {{points}}",
      "noGradingSchemeYet": "لا توجد معايير تقييم بعد.",
      "boxModeContent": "المحتوى",
      "boxModeLanguageUse": "الأداء اللغوي",
      "groupLanguageUseRule": "مجموعة: المهمة {{tasks}}",
      "groupLanguageUseRuleNumbered": "المجموعة {{number}}: المهمة {{tasks}}",
      "editLanguageUseGroupTasks": "تعديل مهام هذه المجموعة",
      "deleteLanguageUseGroup": "حذف قاعدة الأداء اللغوي هذه",
      "deleteLanguageUseGroupConfirm": "هل تريد حذف قاعدة الأداء اللغوي هذه؟ لا يمكن التراجع عن هذا الإجراء.",
      "deleteLanguageUseGroupBlocked": "لا يمكن الحذف أثناء التصحيح الجاري.",
      "languageUseGroupPickerInfo": "حدد مهمة لإضافتها إلى هذه المجموعة. أزل التحديد لإزالتها — إذا كانت لا تزال بحاجة إلى قاعدة الأداء اللغوي الخاصة بها، يتم تعبئتها مسبقًا بنص هذه المجموعة و0 نقطة حتى تتمكن من إيجادها مجددًا.",
      "languageUseGroupPickerSaveFailed": "فشل الحفظ. يرجى المحاولة مرة أخرى.",
      "languageUseGroupPickerEmptyDraft": "تحتاج القاعدة إلى مهمة واحدة على الأقل.",
      "deleteBox": "حذف مربع المحيط",
      "retryOcr": "إعادة محاولة التعرف على النص",
      "unlockBox": "إلغاء قفل مربع المحيط",
      "lockBox": "قفل مربع المحيط",
      "noSubmissionsFound": "لم يتم العثور على إجابات.",
      "examPageX": "صفحة الامتحان {{page}}",
      "rerunningOcr": "إعادة تشغيل التعرف على النص...",
      "regrading": "إعادة التقييم...",
      "regradingQueued": "في قائمة الانتظار..."
    },
    "msgs": {
      "noTasksFound": "لم يتم العثور على أسئلة.",
      "prevTask": "السؤال السابق",
      "nextTask": "السؤال التالي",
      "task": "السؤال",
      "taskMain": "السؤال {{main}}",
      "taskSub": "السؤال {{main}}.{{sub}}",
      "uncertaintiesLeft": "تبقت {{count}} من حالات عدم اليقين",
      "nextUncertainty": "حالة عدم اليقين التالية ({{count}})",
      "taskExcerpt": "جزء من السؤال",
      "noImageAvailable": "لا توجد صورة متاحة...",
      "masterSolution": "الحل النموذجي",
      "aiGeneratedProposalTooltip": "اقتراح تم إنشاؤه بواسطة الذكاء الاصطناعي",
      "aiGeneratedProposal": "اقتراح من الذكاء الاصطناعي",
      "review": "مراجعة",
      "approvalRequiresPoints": "لا يمكن الموافقة إلا عندما تكون النقاط أكبر من 0.",
      "saveRequiresPoints": "لا يمكن الحفظ إلا عندما تكون النقاط أكبر من 0.",
      "enterMasterSolution": "أدخل الحل النموذجي هنا...",
      "noMasterSolutionYet": "لا يوجد حل نموذجي بعد...",
      "gradingScheme": "معايير التقييم",
      "maxPoints": "الحد الأقصى للنقاط",
      "maxPointsValue": "الحد الأقصى للنقاط: {{points}}",
      "enterGradingScheme": "أدخل معايير التقييم هنا...",
      "noGradingSchemeYet": "لا توجد معايير تقييم بعد...",
      "gradingSchemeRefining": "جارٍ تحديث معايير التقييم...",
      "masterSolutionRefining": "جارٍ تحديث الحل النموذجي..."
    },
    "submissionCheck": {
      "pageShort": "ص. {{page}}",
      "zoomPage": "تكبير الصفحة {{page}}",
      "pageAlt": "صفحة",
      "loading": "جاري التحميل...",
      "newStudent": "طالب جديد",
      "readOnly": "للقراءة فقط",
      "saving": "جاري الحفظ...",
      "saved": "تم الحفظ",
      "unsavedUnassigned": "لم يتم الحفظ – صفحات غير مخصصة",
      "unsavedUnassignedHint": "اسحب كل الصفحات غير المخصصة إلى طالب، وسيتم الحفظ تلقائيًا.",
      "saveFailed": "لم يتم الحفظ – خطأ",
      "saveFailedHint": "فشل الحفظ. ستتم إعادة المحاولة عند التغيير التالي أو عند الإغلاق.",
      "reloaded": "تمت إعادة التحميل",
      "reloadedHint": "تغيّرت التسليمات في هذه الأثناء. تمت إعادة تحميل التخصيص المحفوظ.",
      "unassignedPagesTitle": "بحاجة إلى توضيح: صفحات غير مخصصة ({{count}})",
      "unassignedPagesHint": "يرجى سحب هذه الصفحات إلى مجلدات الطلاب.",
      "newStudentIndexed": "طالب جديد {{index}}",
      "studentIndexed": "الطالب {{index}}",
      "enterName": "أدخل الاسم...",
      "pageX_one": "صفحة واحدة",
      "pageX_other": "{{count}} صفحات",
      "splitConfidenceHover": "ثقة التقسيم: {{percent}}%",
      "splitPercent": "تقسيم {{percent}}%",
      "deleteStudent": "حذف الطالب",
      "dragHint": "اسحب المستندات هنا لتخصيصها لـ {{name}}",
      "assignmentNotes": "ملاحظات التخصيص",
      "previewPageAlt": "معاينة الصفحة {{page}}",
      "pageCurrentOfTotal": "الصفحة {{current}} من أصل {{total}}",
      "locked": "مؤكد",
      "lockedHint": "مؤكد بالفعل – لا يمكن تعديله."
    },
    "summary": {
      "studentsOverview": "ملخص لكل طالب",
      "studentsOverviewDesc": "النقاط التفصيلية وتقييم الذكاء الاصطناعي لكل سؤال",
      "searchStudent": "البحث عن اسم الطالب...",
      "student": "الطالب",
      "pointsAbbr": "ن.",
      "total": "الإجمالي",
      "percentage": "النسبة المئوية",
      "grade": "الدرجة",
      "noHits": "لا توجد نتائج.",
      "aiConfidenceHover": "ثقة الذكاء الاصطناعي: {{percent}}% - يرجى التحقق يدويًا",
      "aiUncertainties": "حالات عدم يقين الذكاء الاصطناعي",
      "aiUncertaintiesDesc": "راجع الحالات التي يكون فيها الذكاء الاصطناعي غير متأكد لضمان تقييمات عادلة.",
      "openDecisions": "{{count}} قرارات معلقة",
      "sortBy": "ترتيب حسب",
      "task": "السؤال",
      "aiUncertainty": "عدم يقين الذكاء الاصطناعي",
      "confidence": "ثقة الذكاء الاصطناعي:",
      "points": "النقاط:",
      "toGrading": "إلى التقييم",
      "confirmed": "مؤكد",
      "confirm": "تأكيد",
      "noClarificationNeeded": "لا توجد حاجة للتوضيح.",
      "worstAvg": "أسوأ متوسط",
      "noDataYet": "لا توجد بيانات بعد",
      "avgSuffix": "في المتوسط",
      "frequentErrors": "مصادر الأخطاء الأكثر شيوعًا",
      "metricsPerTask": "المقاييس لكل سؤال",
      "gradeDistribution": "توزيع الدرجات",
      "count": "العدد",
      "pdfReports": "تقارير PDF",
      "downloadingPdf": "جاري إنشاء تقارير PDF...",
      "downloadPdf": "تنزيل تقارير PDF",
      "csvExport": "تصدير الدرجات كـ CSV",
      "notConnected": "غير متصل بعد",
      "notMet": "لم يستوف الشروط",
      "downloadingCsv": "جاري إنشاء ملف CSV...",
      "downloadCsv": "تنزيل ملف CSV",
      "gradeScale": "مفتاح الدرجات",
      "gradeFrom": "الدرجة {{grade}} من",
      "normalDistribution": "التوزيع الطبيعي (منحنى غاوس)",
      "activated": "مفعّل",
      "deactivated": "معطّل",
      "curveStrength": "قوة منحنى التعديل",
      "curvingComingSoon": "ميزة تعديل المنحنى غير متاحة بعد. ستتوفر قريبًا.",
      "noSubmissionsFound": "لم يتم العثور على إجابات مصححة.",
      "avgPointsReached": "Ø متوسط النقاط المحققة",
      "pointsReached": "النقاط المحققة",
      "gradeSystem": "نظام الدرجات",
      "gradeBorders": "حدود الدرجات",
      "lowestGradeLabel": "أدنى درجة (من 0%)",
      "tabs": {
        "students": "نظرة عامة على الطلاب",
        "clarification": "بحاجة إلى توضيح",
        "insights": "رؤى الأسئلة",
        "grades": "توزيع الدرجات",
        "curving": "مفتاح الدرجات والمنحنى",
        "export": "تصدير",
        "languageUse": "الأداء اللغوي & القواعد اللغوية"
      },
      "gradingScales": {
        "german16": "الألماني (1–6)",
        "drittel": "أثلاث (1.0–5.0)",
        "af": "A–F",
        "gpa4": "4.0 GPA",
        "notenpunkte": "نقاط الدرجات (0–15)",
        "numeric10": "10 نقاط",
        "percentage": "النسبة المئوية",
        "custom": "مخصص"
      },
      "grammar": "القواعد اللغوية",
      "fehlerindex": "مؤشر الأخطاء (FI)",
      "grammarFiColumnHint": "يشمل فقط المهام التي ما زالت تُقيَّم عبر مؤشر الأخطاء؛ المهام المقيَّمة بالقواعد لها أعمدة خاصة بها.",
      "taskLanguageUseColumn": "{{label}} · الأداء اللغوي",
      "grammarTab": {
        "noGrammarTasks": "لا يحتوي هذا الامتحان على مهام بتقييم لغوي.",
        "fiTitle": "خصم مؤشر الأخطاء",
        "fiDesc": "مؤشر الأخطاء = عدد الأخطاء لكل 100 كلمة. تجاوز الحدود يخفض الدرجة النهائية بدرجات.",
        "fiUnsupportedScale": "لا يمكن الخصم بدرجات مع مقياس النسبة المئوية.",
        "fiAbove": "إذا تجاوز مؤشر الأخطاء",
        "deductSteps": "الخصم (درجات)",
        "matrixTitle": "الأخطاء اللغوية لكل طالب ومهمة",
        "matrixDesc": "عدد الأخطاء (مؤشر الأخطاء بين قوسين). النقر على خلية يفتح التصحيح في وضع القواعد اللغوية.",
        "fiSwitchTitle": "تطبيق مؤشر الأخطاء لهذا الاختبار",
        "fiSwitchDesc": "يستخدم افتراضيًا إعداد ملفك الشخصي؛ فعّله لتجاوزه لهذا الاختبار فقط.",
        "gradeWithFi": "الدرجة (مع مؤشر الأخطاء)"
      },
      "languageUseTab": {
        "rulesOverviewTitle": "قواعد الأداء اللغوي المستخدمة في التقييم",
        "ownRuleEntry": "{{label}}: قاعدة خاصة ({{points}} نقطة)",
        "groupRuleEntry": "{{label}} ({{points}} نقطة)",
        "teacherRulesActive": "يتم تقييم الأداء اللغوي مباشرة أثناء التصحيح وفق قواعدك الشخصية. خصم مؤشر الأخطاء معطّل."
      }
    },
    "structureEditor": {
      "pointsInconsistent": "النقاط غير متطابقة. في كل مستوى، إمّا أن تمنح جميع المهام نقاطًا (يكون مجموعها مساويًا لإجمالي المهمة الأصلية) أو تتركها جميعًا فارغة. صحّح المهام المميّزة:",
      "pointsInconsistentTask": "المهمة {{path}} تنقصها نقاط",
      "totalPoints": "إجمالي النقاط (شاملة المهام الفرعية)",
      "ownPoints": "النقاط الخاصة (إجابة هذه المهمة نفسها)",
      "tasksWithoutRegion": "مهام بدون منطقة محددة",
      "noPages": "لا توجد صفحات متاحة.",
      "taskAreasDetected_one": "تم التعرف على منطقة سؤال واحدة",
      "taskAreasDetected_other": "تم التعرف على {{count}} مناطق أسئلة",
      "addArea": "إضافة منطقة",
      "remove": "إزالة",
      "resetZoom": "إعادة تعيين التكبير",
      "readOnly": "للقراءة فقط",
      "saving": "جاري الحفظ...",
      "saved": "تم الحفظ",
      "blankExamPage": "صفحة امتحان فارغة {{page}}",
      "deleteBbx": "حذف مربع المحيط",
      "retryOcr": "إعادة محاولة التعرف على النص",
      "noTasksOnPage": "لا توجد أسئلة في هذه الصفحة",
      "task": "السؤال",
      "noText": "لا يوجد نص",
      "imageContent": "صورة (لا يوجد تعرّف على النص) - سيتم استخدام جزء الصورة الذي تم التعرف عليه مباشرة لمزيد من المعالجة",
      "additionalInfo": "معلومات إضافية",
      "noContent": "لا يوجد محتوى",
      "linkedTasks": "الأسئلة المرتبطة",
      "noTasks": "لا توجد أسئلة"
    },
    "demoSelector": {
      "title": "اختيار النسخة التجريبية",
      "description": "اختر امتحانًا تجريبيًا. سيقوم gradias بمحاكاة الرفع وبدء الاستخراج تلقائيًا.",
      "examCount_one": "امتحان واحد",
      "examCount_other": "{{count}} امتحانات",
      "studentCount_one": "طالب واحد",
      "studentCount_other": "{{count}} طلاب",
      "examLanguage": "لغة الامتحان",
      "subjects": {
        "math": "الرياضيات",
        "english": "الإنجليزية",
        "technical": "المدرسة المهنية",
        "biology": "الأحياء",
        "spanish": "الإسبانية",
        "french": "الفرنسية",
        "physics": "الفيزياء",
        "political_education": "التربية السياسية",
        "german": "الألمانية"
      },
      "grades": {
        "gesamtschule": "المدرسة الشاملة",
        "highSchool": "المدرسة الثانوية",
        "elementarySchool": "المدرسة الابتدائية",
        "vocationalSchool": "تعليم الكبار",
        "middleSchool": "المرحلة المتوسطة",
        "university": "الجامعة",
        "primarySchool": "المدرسة الابتدائية"
      },
      "exams": {
        "kaarst": {
          "name": "الرياضيات - مناقشة المنحنيات",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "arne": {
          "name": "الرياضيات - الكسور للصف السادس",
          "description": "إجابات الطلاب"
        },
        "lynehamMath": {
          "name": "الرياضيات",
          "description": "إجابات الطلاب"
        },
        "tuevBauleiter": {
          "name": "مدير الموقع الإنشائي",
          "description": "إجابات الطلاب والحل النموذجي"
        },
        "tuvPhotovoltaik": {
          "name": "الأنظمة الكهروضوئية",
          "description": "إجابات الطلاب والحل النموذجي"
        },
        "engVocabulary": {
          "name": "اختبار مفردات (الإنجليزية)",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "bioImageLabeling": {
          "name": "تسمية الصور (الأحياء)",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي والامتحان الفارغ"
        },
        "mathProofFr": {
          "name": "برهان رياضي",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي والامتحان الفارغ"
        },
        "mathProofEng": {
          "name": "برهان رياضي",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي والامتحان الفارغ"
        },
        "plotting": {
          "name": "رسم دالة بيانية",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي والامتحان الفارغ"
        },
        "curveAnalysis": {
          "name": "مناقشة المنحنيات",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي والامتحان الفارغ"
        },
        "calculationDe": {
          "name": "الفيزياء",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "dictationFr": {
          "name": "إملاء — الفرنسية",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "dictationEs": {
          "name": "إملاء — الإسبانية",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "calculationFr": {
          "name": "حساب",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "calculationEs": {
          "name": "حساب",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "calculationEn": {
          "name": "حساب",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "multipleChoiceDe": {
          "name": "اختيار من متعدد",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "multipleChoiceEn": {
          "name": "اختيار من متعدد",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "multipleChoiceFr": {
          "name": "اختيار من متعدد",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "multipleChoiceEs": {
          "name": "اختيار من متعدد",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "politics12German": {
          "name": "التربية السياسية — الصف الثاني عشر",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "poetry12German": {
          "name": "تحليل الشعر — الصف الثاني عشر",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "poetry12English": {
          "name": "تحليل الشعر — الصف الثاني عشر",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "poetry12French": {
          "name": "تحليل الشعر — الصف الثاني عشر",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "materialBasedEnglish": {
          "name": "مقال قائم على مواد",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        },
        "materialBasedGerman": {
          "name": "مقال قائم على مواد",
          "description": "مجموعة بيانات كاملة: إجابات الطلاب، الحل النموذجي، معايير التقييم والامتحان الفارغ"
        }
      }
    },
    "examEditor": {
      "savingAndRecompiling": "جارٍ الحفظ وإعادة التجميع…",
      "unsavedChanges": "تغييرات غير محفوظة",
      "allChangesSaved": "تم حفظ جميع التغييرات",
      "readOnlyBanner": "هذا الاختبار مقفل: توجد بالفعل حل نموذجي أو مخطط تقييم أو إجابات طلاب، لذا لم تعد التعديلات ممكنة هنا.",
      "generatingExam": "جارٍ إنشاء الاختبار…",
      "refiningExam": "جارٍ تحديث الاختبار…",
      "downloadPdf": "تنزيل PDF",
      "confirmCreation": "تأكيد الاختبار",
      "confirmingCreation": "جارٍ التأكيد…",
      "confirmHint": "أكّد الاختبار لإنهاء التعديل. التنزيل والتسليم عبر الإنترنت متاحان فقط بعد هذا التأكيد النهائي، ولا يمكن تعديل الاختبار بعد ذلك.",
      "confirmed": "تم التأكيد",
      "readOnly": "للقراءة فقط",
      "confirmedBanner": "تم تأكيد هذا الاختبار ولم يعد قابلاً للتعديل. التنزيل والتسليم عبر الإنترنت متاحان.",
      "confirmFailed": "تعذّر تأكيد الاختبار: {{message}}",
      "preparingPdf": "جارٍ تجهيز ملف PDF…",
      "notSaved": "لم يتم الحفظ: {{message}}",
      "seeProblemsBelow": "انظر المشاكل أدناه",
      "noExam": "لا يوجد اختبار.",
      "noSourceYet": "لا يوجد مصدر لهذا الاختبار بعد.",
      "noPreviewYet": "لا توجد معاينة مُجمَّعة بعد — انقر على أي كتلة أو نقطة للتعديل وإنشاء واحدة.",
      "tellAiPlaceholder": "أخبر الذكاء الاصطناعي بما تريد تغييره ...",
      "delete": "حذف",
      "applying": "جارٍ التطبيق …",
      "send": "إرسال",
      "done": "تم",
      "describeAiPlaceholder": "صف للذكاء الاصطناعي المهمة التي تريد إضافتها هنا ...",
      "add": "إضافة",
      "adding": "جارٍ الإضافة …",
      "task": "المهمة {{number}}",
      "taskNumber": "رقم المهمة",
      "type": "النوع",
      "points": "النقاط",
      "lines": "الأسطر",
      "taskText": "نص المهمة",
      "material": "المادة",
      "title": "العنوان",
      "usedByTasks": "مستخدَم من قبل المهام (أرقام مفصولة بفواصل)",
      "text": "النص",
      "multipleChoice": "اختيار من متعدد",
      "removeOption": "إزالة الخيار",
      "addOption": "+ إضافة خيار",
      "figureProperties": "خصائص الشكل",
      "caption": "التعليق التوضيحي",
      "examSetup": "إعداد الاختبار",
      "subject": "المادة الدراسية",
      "class": "الصف",
      "duration": "المدة",
      "totalPoints": "مجموع النقاط",
      "globalHints": "إرشادات / تعليمات عامة",
      "studentView": "التعبئة عبر الإنترنت"
    }
  },
  "TaskTypeDescs": {
    "taskFrame": "يجمع الأسئلة الفرعية، ولا يتطلب إجابة خاصة به",
    "default": "نوع سؤال عام، إذا لم يناسبه أي نوع آخر",
    "shortText": "إجابة مكتوبة قصيرة (جمل قليلة)",
    "essay": "نص إنشائي أطول ومنظم",
    "diagram": "رسم تقني، مثل مخطط التدفق أو الدائرة الكهربائية",
    "sketch": "رسم حر أو مسودة",
    "gapText": "ملء الفراغات في النص",
    "labelImage": "تسمية أجزاء من صورة أو مخطط",
    "multipleChoice": "الاختيار من بين الخيارات المحددة",
    "imageAnalysis": "وصف أو تفسير صورة",
    "mapping": "توصيل الكائنات / البدائل المتطابقة",
    "legalCase": "قضية قانونية (أسلوب التقييم القانوني)",
    "calculation": "حساب رياضي أو فيزيائي",
    "mathematicalProof": "برهان رياضي رسمي",
    "curveAnalysis": "مناقشة المنحنيات (الأصفار، القيم القصوى، ...)",
    "plotting": "رسم منحنى أو دالة أو نقاط في نظام الإحداثيات",
    "geometry": "إنشاءات هندسية أو حسابات (رسم)",
    "programming": "كتابة أو تحليل الكود المصدري",
    "art": "إنشاء عمل فني أو تصميم فني",
    "dictation": "كتابة نص مملى",
    "translation": "ترجمة نص أو كلمات إلى لغة أخرى",
    "chemicalFormula": "معادلات تفاعل كيميائي أو صيغ كيميائية",
    "music": "قراءة أو كتابة النوتات الموسيقية",
    "literaryAnalysisPoetry": "تحليل قصيدة",
    "analysisNonFiction": "تحليل نص غير روائي",
    "materialBasedEssay": "كتابة مقال بناءً على مواد مقدَّمة"
  },
  "TaskTypes": {
    "taskFrame": "إطار المهمة",
    "default": "قياسي",
    "shortText": "نص قصير",
    "essay": "مقال",
    "diagram": "مخطط",
    "sketch": "رسم مبدئي",
    "gapText": "نص الفراغات",
    "labelImage": "تسمية الصورة",
    "multipleChoice": "اختيار من متعدد",
    "imageAnalysis": "تحليل الصور",
    "mapping": "توصيل",
    "legalCase": "قضية قانونية",
    "calculation": "حساب",
    "mathematicalProof": "برهان رياضي",
    "curveAnalysis": "مناقشة المنحنيات",
    "plotting": "رسم بياني",
    "geometry": "الهندسة",
    "programming": "البرمجة",
    "art": "الفن",
    "dictation": "إملاء",
    "translation": "ترجمة",
    "chemicalFormula": "صيغة كيميائية",
    "music": "الموسيقى",
    "literaryAnalysisPoetry": "تحليل الشعر",
    "analysisNonFiction": "تحليل نص غير روائي",
    "materialBasedEssay": "مقال قائم على مواد"
  },
  "GapText": {
    "gap": "فراغ",
    "correct": "صحيح",
    "incorrect": "خاطئ",
    "empty": "فارغ",
    "points": "نقاط",
    "expectedAnswer": "الإجابة المتوقعة",
    "studentAnswer": "إجابة الطالب",
    "status": "الحالة"
  },
  "progress": {
    "analyzingSplit": "جاري تحليل التقسيم",
    "extractingAnswers": "جاري استخراج إجابات الطلاب...",
    "errorExtractingAnswers": "خطأ أثناء استخراج إجابات الطلاب",
    "answersExtracted": "تم استخراج إجابات الطلاب",
    "extractingMasterSolution": "استخراج محتويات الحل النموذجي",
    "errorStructureMasterSolution": "خطأ أثناء إنشاء بنية الأسئلة (الحل النموذجي)",
    "errorExtractingMasterSolution": "خطأ أثناء استخراج الحل النموذجي",
    "masterSolutionExtracted": "تم استخراج الحل النموذجي",
    "extractingGradingScheme": "استخراج معايير التقييم",
    "errorStructureGradingScheme": "خطأ أثناء إنشاء بنية الأسئلة (معايير التقييم)",
    "errorExtractingGradingScheme": "خطأ أثناء استخراج معايير التقييم",
    "gradingSchemeExtracted": "تم استخراج معايير التقييم",
    "noUsableMasterSolution": "لم يتم التعرف على أي محتويات قابلة للاستخدام للحل النموذجي. يرجى التحقق من الملف أو تعديل التخصيص.",
    "noUsableGradingScheme": "لم يتم التعرف على أي معايير تقييم قابلة للاستخدام. يرجى التحقق من الملف أو تعديل التخصيص.",
    "analyzingStructure": "جاري تحليل بنية الامتحان",
    "noSubmissions": "لا توجد إجابات متاحة",
    "errorStructureAnalysis": "خطأ في تحليل بنية الامتحان",
    "noTasksInStructure": "لم يتم العثور على أسئلة في تحليل البنية",
    "extractingTaskDescriptions": "استخراج أوصاف الأسئلة",
    "errorTaskDescriptions": "خطأ أثناء استخراج أوصاف الأسئلة",
    "taskDescriptionsExtracted": "تم استخراج أوصاف الأسئلة",
    "taskStructureCreated": "تم إنشاء بنية الأسئلة",
    "waitingForStructureConfirmation": "في انتظار تأكيد بنية الامتحان من قِبل المستخدم",
    "structureConfirmed": "تم تأكيد بنية الامتحان",
    "structureConfirmationTimeout": "انتهت مهلة تأكيد بنية الامتحان",
    "errorWaitingStructureConfirmation": "خطأ أثناء انتظار تأكيد بنية الامتحان",
    "errorProcessingStructureConfirmation": "خطأ أثناء معالجة تأكيد بنية الامتحان",
    "errorCreatingTaskStructure": "خطأ أثناء إنشاء بنية الأسئلة",
    "pipelineFailedPrematurely": "فشلت البنية البرمجية (Pipeline) قبل أوانها",
    "assignmentConfirmed": "تم تأكيد التخصيص",
    "gradingRunning": "التقييم جاري...",
    "gradingTaskX": "جاري تقييم السؤال {{taskNumber}} ...",
    "gradingCompleted": "اكتمل التقييم",
    "gradingTaskXCompleted": "اكتمل تقييم السؤال {{taskNumber}}"
  },
  "upload": {
    "noExamId": "لم يتم العثور على معرف الامتحان",
    "noFileSelected": "لم يتم اختيار أي ملف",
    "processingFailed": "تعذرت معالجة الملف",
    "invalidFileType": "نوع ملف غير صالح. يرجى اختيار ملف PNG أو PDF.",
    "uploadError": "خطأ أثناء رفع الملف",
    "studentName": "الطالب {{index}}",
    "noExamIdForReupload": "خطأ: لا يوجد معرف امتحان لإعادة الرفع.",
    "reuploadCancelled": "معلومات النظام: تم معالجة إلغاء الرفع.",
    "reuploadCancelFailed": "معلومات النظام: تعذر معالجة إلغاء الرفع بالكامل.",
    "filesMissing": "حظر النظام: لم يتم العثور على الملفات التالية في ذاكرة الرفع: {{files}}. يرجى التأكد من تطابق أسماء الملفات تمامًا مع الملفات المرفوعة.",
    "assignmentMismatch": "حظر النظام: تخصيصات الملفات التالية لا تتطابق مع الاقتراح الأخير. يرجى استدعاء send_assignment_confirmation_message وتأكيد التخصيص الجديد مع المستخدم.\n{{lines}}",
    "reuploadStarted": "بدأت إعادة رفع الملفات في الخلفية. {{extra}}",
    "splitStarted": "بدأ تقسيم إجابات الطلاب.",
    "assignmentProposalSent": "تم إرسال رسالة تحتوي على اقتراح التخصيص.",
    "assignmentConfirmationMessage": "لست متأكدًا بعد من تخصيص الملفات وأود منك التحقق من ذلك سريعًا.\n\nيرجى التأكيد في منطقة السحب والإفلات من أن التخصيص المقترح صحيح، أو قم بتعديله هناك. بعد ذلك يمكنني المتابعة مباشرة.",
    "assignmentProposalFallback": "يرجى مراجعة اقتراح التخصيص الخاص بي وتأكيد تخصيص الملفات.",
    "categorySubmissions": "إجابات الطلاب",
    "categoryMasterSolution": "الحل النموذجي",
    "categoryGradingScheme": "معايير التقييم",
    "categoryBlankExam": "امتحان فارغ",
    "lowConfidenceListFormat": "'{{file}}' (مخطط له كـ {{category}})",
    "mismatchFormat": "- {{name}}: تم اقتراحه مؤخرًا كـ \"{{proposed}}\"، والآن تم تمريره كـ \"{{supplied}}\""
  },
  "splitIssues": {
    "unknownStudent": "طالب مجهول",
    "studentNumber": "الطالب {{number}}",
    "pageAssignmentError": "لم يتم تخصيص كل صفحة مرة واحدة بالضبط",
    "nonConsecutive": "تم تخصيص صفحات غير متتالية لـ {{names}} (إعادة ترتيب بواسطة الوكلاء)",
    "uncertainty": "عدم يقين عند {{names}}",
    "outlierLongExtremeSingle": "إجابة {{names}} طويلة للغاية",
    "outlierLongExtremePlural": "إجابات {{names}} طويلة للغاية",
    "outlierShortExtremeSingle": "إجابة {{names}} قصيرة للغاية",
    "outlierShortExtremePlural": "إجابات {{names}} قصيرة للغاية",
    "outlierLongSingle": "إجابة {{names}} طويلة بشكل غير عادي",
    "outlierLongPlural": "إجابات {{names}} طويلة بشكل غير عادي",
    "outlierShortSingle": "إجابة {{names}} قصيرة بشكل غير عادي",
    "outlierShortPlural": "إجابات {{names}} قصيرة بشكل غير عادي",
    "missingStudentNameSingle": "تعذر استخراج الاسم لـ {{missingCount}} من أصل {{totalCount}} طلاب",
    "missingStudentNamePlural": "تعذر استخراج الأسماء لـ {{missingCount}} من أصل {{totalCount}} طلاب",
    "splitAgentFailure": "خطأ في وكيل التقسيم {{suffix}}",
    "errorPrefix": "خطأ",
    "warningPrefix": "تحذير",
    "parseErrorFallback": "تعذرت معالجة البيانات. يرجى التحقق من التخصيص في الكانفاس.",
    "messageError": "لقد وجدت {{count}} طلاب وبحوزة كل منهم {{range}} صفحات، ولكن حدثت مشكلة أثناء التخصيص التلقائي للصفحات:\n{{problem}}\n\nيرجى التحقق من التخصيص في كانفاس التخصيص وتصحيحه يدويًا عند الحاجة. بمجرد انتهائك، يرجى التأكيد في الدردشة أو عبر الزر لنتمكن من المتابعة.",
    "messageWarning": "لقد وجدت {{count}} طلاب وبحوزة كل منهم {{range}} صفحات، ولكن هناك الملاحظات التالية:\n{{problem}}\n\nإذا كنت ترغب في ذلك، يمكنك مراجعة الملاحظات في كانفاس التخصيص. بخلاف ذلك، ما عليك سوى التأكيد لنتمكن من المتابعة.",
    "messageSuccess": "لقد وجدت {{count}} طلاب وبحوزة كل منهم {{range}} صفحات. كان التخصيص واضحًا ومحددًا. تم استخراج الاسم لجميع الطلاب. يرجى التأكيد لنتمكن من المتابعة.",
    "confirmationRequested": "تم طلب تأكيد التقسيم",
    "splitAgentFailed": "فشل التخصيص التلقائي لإجابات الطلاب. يرجى محاولة رفع الملفات مرة أخرى لاحقًا."
  },
  "structureIssues": {
    "pointsExplanation": "\n\n**حول النقاط:** لقد اكتشفت نقاطًا لبعض المهام. إذا رفعت مخطط تقييم يتضمّن النقاط (أو سبق أن رفعته)، فستُؤخذ النقاط منه؛ عندئذٍ يمكنك تجاهل النقاط في اللوحة. فهي مهمة فقط إذا كان مخطط التقييم لا يتضمّن هذه النقاط أو كنت تريد إنشاء واحد.\n\nقواعد توزيع النقاط: لكل مهمة، إما أن تمنح جميع المهام الفرعية المباشرة نقاطًا يكون مجموعها مساويًا لإجمالي المهمة الأصلية، أو لا تمنح أيًّا منها. إذا لم تمنح المهام الفرعية نقاطًا بل إجماليًا فقط، فسيوزّعها الذكاء الاصطناعي تلقائيًا لاحقًا عند إنشاء مخطط التقييم.",
    "textCutoff": "نص السؤال غير مكتمل",
    "missingInformation": "معلومات مفقودة",
    "imageUnreadable": "الصورة غير مقروءة",
    "task": "السؤال",
    "mainTasks_one": "لقد تعرّفتُ على سؤال رئيسي واحد.",
    "mainTasks_other": "لقد تعرّفتُ على {{mainCount}} أسئلة رئيسية.",
    "mainAndSubTasks_one": "لقد تعرّفتُ على {{mainCount}} أسئلة رئيسية وسؤال فرعي واحد.",
    "mainAndSubTasks_other": "لقد تعرّفتُ على {{mainCount}} أسئلة رئيسية و{{subCount}} أسئلة فرعية.",
    "intro": "### لقد حددت بنية الأسئلة التالية:\n\n{{countText}}",
    "problemsIntro": "\n\nحدثت المشكلات التالية أثناء التعرف على الأسئلة: {{warnings}}. يرجى إلقاء نظرة على حالات عدم اليقين في الكانفاس، وتعديلها عند الحاجة، ثم التأكيد عبر الزر أو في الدردشة.",
    "uncertaintyIntro": "\n\nهناك حالات عدم يقين عند {{labels}} أثناء التعرف على الأسئلة. يرجى إلقاء نظرة على حالات عدم اليقين في الكانفاس، وتعديلها عند الحاجة، ثم التأكيد عبر الزر أو في الدردشة.",
    "success": "\n\nلم تحدث أي مشكلات أثناء التعرف على الأسئلة. إذا أردت، يمكنك إلقاء نظرة فاحصة عليها في الكانفاس على أي حال، وإلا فيرجى التأكيد عبر الزر أو في الدردشة."
  },
  "chatMessages": {
    "emptyState": "ابدأ محادثة عن طريق كتابة رسالة أدناه",
    "newMessage": "رسالة جديدة",
    "cancel": "إلغاء",
    "send": "إرسال",
    "edit": "تعديل",
    "editInCanvas": "تعديل في الكانفاس",
    "confirmed": "مؤكد",
    "confirm": "تأكيد",
    "confirmAssignment": "تأكيد التخصيص",
    "giveFeedback": "إرسال ملاحظات",
    "feedbackTitle": "إرسال ملاحظات",
    "feedbackDescription": "أخبرنا كيف يمكننا تحسين هذه الإجابة.",
    "feedbackPlaceholder": "ملاحظاتك هنا...",
    "feedbackSubmit": "إرسال الملاحظات",
    "submitAssignmentConfirmation": "أنا أؤكد تقسيم الصفحات وتخصيصها للطلاب. يرجى المتابعة.",
    "submitStructureConfirmation": "أنا أؤكد بنية الأسئلة",
    "studentSubmissions": "إجابات الطلاب",
    "masterSolution": "الحل النموذجي",
    "gradingScheme": "معايير التقييم",
    "blankExam": "امتحان فارغ",
    "confirmedAssignmentIntro": "تخصيص الملف المؤكد:",
    "assignmentIntro": "لقد قمت بتخصيص الملفات على النحو التالي. يرجى التحقق من التخصيص وتأكيده:"
  },
  "AuthModal": {
    "loginError": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
    "signupFailed": "فشل التسجيل. يرجى المحاولة مرة أخرى.",
    "passwordMismatch": "كلمات المرور غير متطابقة.",
    "forgotPasswordProblem": "حدثت مشكلة. يرجى المحاولة مرة أخرى لاحقًا.",
    "waitlistTitle": "أنت على قائمة الانتظار!",
    "waitlistDesc": "سنتصل بك بمجرد بدء المرحلة التالية.",
    "waitlistInactive": "قائمة الانتظار معطلة حاليًا.",
    "backToLogin": "العودة إلى تسجيل الدخول",
    "linkSentTitle": "تحقق من بريدك الوارد",
    "linkSentBody": "إذا كان هناك حساب مؤكد بعنوان البريد الإلكتروني هذا، فستتلقى قريبًا رابطًا لإعادة تعيين كلمة المرور. الرابط صالح لمدة ساعة واحدة. تحقق أيضًا من مجلد البريد العشوائي. لم تصلك رسالة؟ يرجى التسجيل إذن.",
    "linkSentDesc": "مفهوم",
    "linkSentRegister": "الانتقال إلى التسجيل",
    "forgotPasswordTitle": "هل نسيت كلمة المرور؟",
    "requestLink": "طلب الرابط",
    "welcomeBack": "مرحبًا بك مجددًا",
    "createAccount": "إنشاء حساب",
    "emailLabel": "البريد الإلكتروني",
    "passwordLabel": "كلمة المرور",
    "forgotPasswordLink": "هل نسيت كلمة المرور؟",
    "loginButton": "تسجيل الدخول",
    "firstNameLabel": "الاسم الأول",
    "lastNameLabel": "اسم العائلة",
    "schoolLabel": "المدرسة",
    "subjectsLabel": "المواد الدراسية",
    "confirmPasswordLabel": "تأكيد",
    "signupButton": "التسجيل",
    "registerHere": "سجل هنا",
    "loginHere": "سجل الدخول هنا",
    "continueGuest": "المتابعة دون تسجيل الدخول ←",
    "or": "أو",
    "continueWithGoogle": "المتابعة باستخدام Google",
    "roleTeacher": "معلم",
    "roleStudent": "طالب",
    "emailNotVerified": "يرجى تأكيد عنوان بريدك الإلكتروني أولًا باستخدام الرمز الذي أرسلناه إلى:",
    "verifyEmailTitle": "أكّد عنوان بريدك الإلكتروني",
    "verifyEmailDesc": "أرسلنا رمز التأكيد إلى:",
    "verifyEmailHint": "الرمز صالح لمدة 15 دقيقة. تحقق أيضًا من مجلد البريد العشوائي.",
    "verifyEmailResend": "إرسال رمز جديد",
    "verifyEmailResent": "أرسلنا إليك رمزًا جديدًا.",
    "verifyEmailWrongAddress": "عنوان خاطئ؟ غيّره",
    "verifyCodeLabel": "رمز التأكيد",
    "verifyCodeButton": "تأكيد",
    "verifyCodeInvalid": "الرمز غير صحيح.",
    "verifyCodeExpired": "انتهت صلاحية الرمز أو تم إدخاله بشكل خاطئ مرات كثيرة. اطلب رمزًا جديدًا.",
    "changeRole": "تغيير الدور",
    "roleQuestion": "هل أنت معلم أم طالب؟",
    "passwordRequirements": "8 أحرف على الأقل، مع أحرف كبيرة وصغيرة ورقم ورمز خاص.",
    "passwordInvalid": "كلمة المرور لا تستوفي المتطلبات.",
    "emailInvalid": "يرجى إدخال عنوان بريد إلكتروني صالح.",
    "googleNoAccount": "لا يوجد حساب بعد لعنوان Google هذا. يرجى التسجيل أولاً."
  },
  "FeedbackPage": {
    "alerts": {
      "imageTooLarge": "الصورة \"{{name}}\" كبيرة جدًا (الحد الأقصى 5 ميجابايت).",
      "previewError": "تعذر إنشاء المعاينة لـ {{name}}.",
      "submitError": "حدث خطأ ما. يرجى المحاولة مرة أخرى."
    },
    "success": {
      "title": "شكرًا جزيلاً على ملاحظاتك!",
      "description": "لقد استلمنا رسالتك. تساعدنا مدخلاتك بشكل هائل في جعل Gradias أفضل قليلاً كل يوم.",
      "backButton": "العودة إلى الامتحان"
    },
    "header": {
      "title": "إرسال ملاحظات"
    },
    "content": {
      "description": "هل لاحظت خطأً، أو لديك فكرة عبقرية، أو تريد ببساطة إخبارنا بشيء ما؟ نحن نقرأ كل رسالة!"
    },
    "categories": {
      "title": "ما هو موضوع الرسالة؟",
      "bug": {
        "title": "خطأ / عطل",
        "desc": "شيء ما لا يعمل"
      },
      "feature": {
        "title": "فكرة / أمنية",
        "desc": "ميزة جديدة"
      },
      "general": {
        "title": "أخرى",
        "desc": "ملاحظات عامة"
      }
    },
    "message": {
      "title": "رسالتك",
      "placeholder": "صف مشكلتك أو اقتراحك بأكبر قدر ممكن من التفاصيل..."
    },
    "upload": {
      "title": "إرفاق لقطة شاشة (اختياري)",
      "clickToSelect": "انقر لاختيار الصور",
      "formatConstraint": "PNG، JPG حتى 5 ميجابايت كحد أقصى لكل صورة",
      "attachedImages": "الصور المرفقة",
      "removeImage": "إزالة الصورة"
    },
    "submit": {
      "sending": "جاري الإرسال...",
      "send": "إرسال الملاحظات"
    }
  },
  "ConfirmationReplies": {
    "split": {
      "confirmed": "تم تأكيد تخصيص الامتحان وعدد الطلاب بنجاح. يمكن الآن بدء استخراج بنية الأسئلة. يرجى شكر المستخدم على تأكيد التخصيص وإبلاغه في الدردشة بأن استخراج بنية الأسئلة سيبدأ الآن.",
      "pending": "تخصيص الامتحان وعدد الطلاب لم يتم تأكيده بعد."
    },
    "structure": {
      "masterAndGrading": "تم تأكيد بنية الأسئلة بنجاح. يستمر الاستخراج الآن في الخلفية. تم بالفعل رفع حل نموذجي ومفتاح تقييم ويتم معالجتهما في الخلفية. اشكر المستخدم باختصار على تأكيد بنية الأسئلة وأخبره باختصار بأن الاستخراج مستمر. اقترح عليه بدء التقييم.",
      "masterOnly": "تم تأكيد بنية الأسئلة بنجاح. يستمر الاستخراج الآن في الخلفية. تم بالفعل رفع حل نموذجي، ولكن مفتاح التقييم لا يزال مفقودًا. اشكر المستخدم باختصار على تأكيد بنية الأسئلة وأخبره باختصار بأن الاستخراج مستمر. اقترح عليه إنشاء معايير تقييم قائمة على الذكاء الاصطناعي كخطوة تالية.",
      "gradingOnly": "تم تأكيد بنية الأسئلة بنجاح. يستمر الاستخراج الآن في الخلفية. تم بالفعل رفع مفتاح التقييم، ولكن الحل النموذجي لا يزال مفقودًا. اشكر المستخدم باختصار على تأكيد بنية الأسئلة وأخبره باختصار بأن الاستخراج مستمر. اقترح عليه إنشاء حل نموذجي قائم على الذكاء الاصطناعي.",
      "none": "تم تأكيد بنية الأسئلة بنجاح. يستمر الاستخراج الآن في الخلفية. لا يزال الحل النموذجي مفقودًا. اشكر المستخدم باختصار على تأكيد بنية الأسئلة، وأخبره باختصار بأن الاستخراج مستمر، واسأله عما إذا كان يفضل في الخطوة التالية، بمجرد اكتمال الاستخراج، إنشاء حل نموذجي قائم على الذكاء الاصطناعي أو إذا كان يريد رفع حل نموذجي عبر مشبك الورق في حقل الإدخال. اذكر في إجابتك كيف يمكن للمستخدم رفع الحل النموذجي، أي باستخدام مشبك الورق في حقل إدخال الدردشة."
    },
    "errors": {
      "notConfirmed": "Confirmation flag is false; nothing to do.",
      "missingIdentifiers": "Missing required identifiers for confirmation.",
      "missingSplitMessage": "خطأ: لم يتم العثور على رسالة تأكيد تقسيم مرتبطة.",
      "missingStructureMessage": "خطأ: لم يتم العثور على رسالة تأكيد بنية مرتبطة.",
      "structureContentMissing": "خطأ: تعذر تحميل رسالة تأكيد البنية.",
      "splitFailure": "خطأ أثناء تأكيد التقسيم.",
      "structureFailure": "خطأ أثناء تأكيد البنية."
    }
  },
  "toolFallbackDesc": {
    "default": "تنفيذ خطوة الأداة",
    "set_metadata": "البيانات الوصفية للامتحان",
    "create_exam": "إنشاء الاختبار الآن",
    "generate_master_solution": "إنشاء الحل النموذجي الآن",
    "refine_master_solution": "تحسين الحل النموذجي بدقة",
    "generate_grading_scheme": "إنشاء معايير التقييم الآن",
    "refine_grading_scheme": "تحسين معايير التقييم بدقة",
    "run_grading_agent": "إجراء التقييم",
    "set_task_score": "تحديد الدرجة يدويًا",
    "open_canvas": "فتح عرض الكانفاس",
    "update_open_task_content": "تحديث نص السؤال مباشرة",
    "send_assignment_confirmation_message": "طلب تأكيد تخصيص الملف",
    "process_files": "معالجة الملفات المرفوعة",
    "confirm_split_in_chat": "تأكيد التخصيص في الدردشة",
    "confirm_structure_in_chat": "تأكيد البنية في الدردشة",
    "confirm_exam_creation": "تأكيد الاختبار",
    "query_exams": "جلب بيانات الامتحان",
    "query_submissions": "جلب إجابات الطلاب",
    "get_available_options": "جلب الخيارات المتاحة",
    "get_task_types": "جلب أنواع الأسئلة",
    "download_ms_gs": "تنزيل الحل النموذجي/معايير التقييم",
    "download_summary_reports": "تنزيل تقرير التقييم",
    "save_teacher_memory": "حفظ التفضيل",
    "get_teacher_memory": "البحث عن التفضيلات",
    "delete_teacher_memory": "حذف التفضيلات",
    "reprocess_errored_submissions": "إعادة معالجة الإجابات التي تحتوي على أخطاء",
    "change_settings": "تغيير الإعدادات"
  },
  "Subjects": {
    "math": "الرياضيات",
    "physics": "الفيزياء",
    "chemistry": "الكيمياء",
    "biology": "الأحياء",
    "history": "التاريخ",
    "geography": "الجغرافيا",
    "english": "الإنجليزية",
    "german": "الألمانية",
    "french": "الفرنسية",
    "spanish": "الإسبانية",
    "computer_science": "علوم الحاسوب",
    "social_studies": "الدراسات الاجتماعية",
    "other": "أخرى"
  },
  "ExamNotifications": {
    "newMessage": "رسالة جديدة"
  },
  "LanguageUseTemplates": {
    "essay": "مستويات الأداء · أداء العرض\n\n* ممتاز:\n  - النص منظم بوضوح ومنطقية، مع روابط فعّالة بين الأقسام.\n  - تُستخدم اللغة المتخصصة بثقة ودقة.\n  - يتم دمج الاقتباسات بشكل صحيح وتقديمها في سياقها؛ وتتضمن الأدلة الإشارة إلى رقم السطر.\n  - التركيب النحوي متنوع، وواثق أسلوبيًا، ومناسب للموضوع الأدبي.\n  - القواعد والتهجئة وعلامات الترقيم خالية من الأخطاء تقريبًا.\n* جيد:\n  - النص منظم بشكل متماسك.\n  - تُستخدم اللغة المتخصصة بثقة في الغالب.\n  - تُستخدم الاقتباسات بشكل مناسب وتُوثَّق بشكل صحيح.\n  - التركيب النحوي صحيح ومتنوع.\n  - أخطاء قليلة في القواعد والتهجئة وعلامات الترقيم.\n* مُرضٍ:\n  - البنية واضحة، لكنها ليست متماسكة باستمرار.\n  - تُستخدم اللغة المتخصصة بشكل وظيفي، لكن ليس دائمًا بدقة.\n  - تُستخدم الاقتباسات، والمراجع صحيحة في الغالب.\n  - التركيب النحوي صحيح في الغالب، ومتكرر الرتابة في بعض الأحيان.\n  - أخطاء القواعد والتهجئة وعلامات الترقيم لا تعيق الفهم.\n* كافٍ:\n  - البنية واضحة بشكل أساسي فقط.\n  - تُستخدم اللغة المتخصصة جزئيًا فقط أو بشكل غير دقيق.\n  - الاقتباسات غير متسقة أو موثّقة بشكل غير كامل.\n  - التركيب النحوي رتيب، مع حالات عدم يقين متكررة.\n  - الدقة اللغوية محدودة؛ ويُعاق الفهم من حين لآخر.\n* ضعيف:\n  - العرض غير منظم إلى حد كبير.\n  - اللغة المتخصصة غائبة إلى حد كبير أو مستخدمة بشكل خاطئ.\n  - الاقتباسات غائبة أو خاطئة.\n  - القصور اللغوي يعيق الفهم بشكل واضح.\n* ضعيف جدًا:\n  - العرض قاصر إلى درجة يصعب فيها فهم العمل.\n  - المتطلبات الأساسية لمقال تفسير أدبي مكتوب غير واضحة.",
    "analysisNonFiction": "مستويات الأداء · أداء العرض\n\n* ممتاز:\n  - النص منظم بوضوح ومنطقية، مع روابط فعّالة بين الأقسام.\n  - تُستخدم اللغة المتخصصة بثقة ودقة.\n  - يتم دمج الاقتباسات بشكل صحيح وتقديمها في سياقها؛ وتتضمن الأدلة الإشارة إلى رقم السطر.\n  - التركيب النحوي متنوع، وواثق أسلوبيًا، ومناسب للموضوع الأدبي.\n  - القواعد والتهجئة وعلامات الترقيم خالية من الأخطاء تقريبًا.\n* جيد:\n  - النص منظم بشكل متماسك.\n  - تُستخدم اللغة المتخصصة بثقة في الغالب.\n  - تُستخدم الاقتباسات بشكل مناسب وتُوثَّق بشكل صحيح.\n  - التركيب النحوي صحيح ومتنوع.\n  - أخطاء قليلة في القواعد والتهجئة وعلامات الترقيم.\n* مُرضٍ:\n  - البنية واضحة، لكنها ليست متماسكة باستمرار.\n  - تُستخدم اللغة المتخصصة بشكل وظيفي، لكن ليس دائمًا بدقة.\n  - تُستخدم الاقتباسات، والمراجع صحيحة في الغالب.\n  - التركيب النحوي صحيح في الغالب، ومتكرر الرتابة في بعض الأحيان.\n  - أخطاء القواعد والتهجئة وعلامات الترقيم لا تعيق الفهم.\n* كافٍ:\n  - البنية واضحة بشكل أساسي فقط.\n  - تُستخدم اللغة المتخصصة جزئيًا فقط أو بشكل غير دقيق.\n  - الاقتباسات غير متسقة أو موثّقة بشكل غير كامل.\n  - التركيب النحوي رتيب، مع حالات عدم يقين متكررة.\n  - الدقة اللغوية محدودة؛ ويُعاق الفهم من حين لآخر.\n* ضعيف:\n  - العرض غير منظم إلى حد كبير.\n  - اللغة المتخصصة غائبة إلى حد كبير أو مستخدمة بشكل خاطئ.\n  - الاقتباسات غائبة أو خاطئة.\n  - القصور اللغوي يعيق الفهم بشكل واضح.\n* ضعيف جدًا:\n  - العرض قاصر إلى درجة يصعب فيها فهم العمل.\n  - المتطلبات الأساسية لمقال تفسير أدبي مكتوب غير واضحة.",
    "genericGroup": "مستويات الأداء · أداء العرض\n\n* ممتاز:\n  - النص منظم بوضوح ومنطقية، مع روابط فعّالة بين الأقسام.\n  - تُستخدم اللغة المتخصصة بثقة ودقة.\n  - يتم دمج الاقتباسات بشكل صحيح وتقديمها في سياقها؛ وتتضمن الأدلة الإشارة إلى رقم السطر.\n  - التركيب النحوي متنوع، وواثق أسلوبيًا، ومناسب للموضوع الأدبي.\n  - القواعد والتهجئة وعلامات الترقيم خالية من الأخطاء تقريبًا.\n* جيد:\n  - النص منظم بشكل متماسك.\n  - تُستخدم اللغة المتخصصة بثقة في الغالب.\n  - تُستخدم الاقتباسات بشكل مناسب وتُوثَّق بشكل صحيح.\n  - التركيب النحوي صحيح ومتنوع.\n  - أخطاء قليلة في القواعد والتهجئة وعلامات الترقيم.\n* مُرضٍ:\n  - البنية واضحة، لكنها ليست متماسكة باستمرار.\n  - تُستخدم اللغة المتخصصة بشكل وظيفي، لكن ليس دائمًا بدقة.\n  - تُستخدم الاقتباسات، والمراجع صحيحة في الغالب.\n  - التركيب النحوي صحيح في الغالب، ومتكرر الرتابة في بعض الأحيان.\n  - أخطاء القواعد والتهجئة وعلامات الترقيم لا تعيق الفهم.\n* كافٍ:\n  - البنية واضحة بشكل أساسي فقط.\n  - تُستخدم اللغة المتخصصة جزئيًا فقط أو بشكل غير دقيق.\n  - الاقتباسات غير متسقة أو موثّقة بشكل غير كامل.\n  - التركيب النحوي رتيب، مع حالات عدم يقين متكررة.\n  - الدقة اللغوية محدودة؛ ويُعاق الفهم من حين لآخر.\n* ضعيف:\n  - العرض غير منظم إلى حد كبير.\n  - اللغة المتخصصة غائبة إلى حد كبير أو مستخدمة بشكل خاطئ.\n  - الاقتباسات غائبة أو خاطئة.\n  - القصور اللغوي يعيق الفهم بشكل واضح.\n* ضعيف جدًا:\n  - العرض قاصر إلى درجة يصعب فيها فهم العمل.\n  - المتطلبات الأساسية لمقال تفسير أدبي مكتوب غير واضحة.",
    "materialBasedEssay": "الكتابة القائمة على المواد (تأليف نصوص جدلية / معلوماتية)\n\nالأداء من حيث المحتوى واستخدام المواد (أداء الفهم / بنية النص):\n* المقدمة موجزة، وتثير اهتمام القارئ، وتقود إلى الموضوع (يتم تجنب الانتقالات المبتذلة).\n* تظهر بنية منطقية تتوافق مع جميع عناصر نوع النص المطلوب (مثل التعليق، المقال، المقالة الصحفية).\n* يتم تحديد الموضوع والمسألة المرتبطة به بوضوح في البداية.\n* يتم شرح المفاهيم الأساسية المهمة بشكل مناسب عند الحاجة.\n* تُؤخذ جميع المواد المقدَّمة بعين الاعتبار وتُدمج في النص بشكل منطقي وصحيح من حيث المحتوى.\n* هناك شفافية في التعامل مع أقوال الآخرين (اقتباس صحيح، وإعادة صياغة، والإشارة إلى المصادر).\n* يتم التمييز بوضوح بين عرض الوقائع والجدال والتقييم الشخصي.\n* الجدال واسع ومتمايز (يأخذ في الاعتبار جوانب مختلفة من الموضوع، وكذلك الحجج المضادة المحتملة).\n* الحجج الفردية مقنعة للجمهور المستهدف، ومنظمة بوضوح، ومُوضَّحة، ومدعومة بالأدلة/الأمثلة.\n* بالإضافة إلى الحجج المستمدة من المواد، يتم تقديم حجج مستقلة ومعرفة تخصصية شخصية.\n* يتم تجميع الجدال في النهاية في خاتمة، قد تليها نظرة استشرافية للمستقبل.\n\nالأداء اللغوي وتصميم النص (أداء العرض):\n* التصميم اللغوي يتوافق مع نوع النص المطلوب، بلغة واضحة ودقيقة وصياغات مستقلة.\n* المفردات، والتحكم في المصطلحات المتخصصة، والأسلوب الوظيفي دقيقة ومتمايزة ومناسبة أسلوبيًا.\n* بناء الجملة واضح ومتنوع ومعقد نحويًا.\n* الأخطاء المعيارية (في القواعد والتهجئة وعلامات الترقيم) لا تعيق سلاسة القراءة.",
    "literaryAnalysisPoetry": "أداء العرض\n* 1. يُنظّم المترشح نصه بشكل متماسك ومنطقي ومتسق وبوضوح فكري:\n  - توزيع مناسب لثقل المهام الفرعية عند التنفيذ\n  - تنظيم مُهيكل ومُوزَّع الثقل بشكل مناسب للعمل\n  - ربط متماسك بين خطوات العمل المختلفة\n  - ربط فكري متماسك بين الجمل\n* 2. يصوغ المترشح أفكاره مع مراعاة متطلبات اللغة المتخصصة والمنهجية الخاصة بالمادة:\n  - التمييز بين مستوى الفعل والمستوى الفوقي (التحليلي)\n  - ربط مُبرَّر بين العبارات الوصفية والتفسيرية والتقييمية\n  - استخدام المصطلحات المتخصصة في سياق ذي معنى\n  - مراعاة الأزمنة النحوية\n  - إعادة صياغة صحيحة للكلام المنقول (الصيغة)\n* 3. يدعم المترشح تصريحاته باقتباسات مناسبة وصحيحة:\n  - استخدام منطقي للاقتباسات الكاملة أو المختصرة بوظيفة داعمة\n* 4. يعبّر المترشح بدقة لغوية عامة، وثقة أسلوبية، وتمايز مفاهيمي:\n  - أسلوب كتابة موضوعي ومتحفّظ\n  - سجل لغوي كتابي\n  - قدرة تعبيرية مفاهيمية تجريدية\n* 5. يصوغ المترشح كلامه بثقة معجمية ونحوية، بشكل متنوع ومعقد (مع الحفاظ على الوضوح في الوقت نفسه).\n* 6. يكتب المترشح بلغة صحيحة نحويًا."
  },
  "LatexEditor": {
    "insertFormula": "معادلة",
    "insertFormulaHint": "إدراج معادلة جديدة عند موضع المؤشر",
    "switchToRawLatex": "التبديل إلى LaTeX الخام",
    "switchToVisualEditor": "التبديل إلى المحرر المرئي",
    "naturalLanguageHint": "صف هذه المعادلة بلغة طبيعية",
    "naturalLanguagePlaceholder": "مثال: „تكامل من 0 إلى 10 لـ x²“",
    "naturalLanguageError": "فشلت الترجمة. حاول مجددا.",
    "insert": "إدراج",
    "removeFormula": "إزالة المعادلة",
    "cancel": "إلغاء"
  },
  "StudentExam": {
    "loading": "جارٍ تحميل الاختبار…",
    "examFallbackTitle": "اختبار",
    "classLabel": "الصف {{class}}",
    "namePlaceholder": "اسمك",
    "answeredCount": "{{answered}} / {{total}} تمت الإجابة عليها",
    "submit": "تسليم",
    "signInRequiredTitle": "تسجيل الدخول مطلوب",
    "signInRequiredBody": "سجّل الدخول لحل هذا الاختبار.",
    "signInAction": "الذهاب إلى تسجيل الدخول",
    "unavailableTitle": "غير متاح",
    "submittedTitle": "تم التسليم",
    "submittedBody": "تم حفظ إجاباتك وهي جاهزة للتصحيح.",
    "errors": {
      "loadFailed": "تعذّر تحميل الاختبار.",
      "notFound": "هذا الاختبار غير موجود.",
      "notSignedIn": "لم يتم تسجيل الدخول.",
      "noAccess": "الاختبار غير موجود أو لا تملك صلاحية الوصول.",
      "noTasks": "لا يحتوي هذا الاختبار على أسئلة بعد.",
      "uploadedExam": "تم رفع هذا الاختبار بدلاً من إنشائه، لذا لا يمكن حله عبر الإنترنت.",
      "notConfirmed": "لم يتم تأكيد هذا الاختبار بعد. أكّده في محرر الاختبارات (أو اطلب ذلك من Gradi) قبل تعبئته عبر الإنترنت.",
      "studentsOnly": "التعبئة عبر الإنترنت متاحة فقط لحسابات الطلاب.",
      "renderFailed": "تعذّر عرض الاختبار.",
      "unreadableAnswers": "تعذّرت قراءة الإجابات.",
      "submitFailed": "فشل التسليم."
    },
    "canvas": {
      "undo": "تراجع",
      "clear": "مسح",
      "pen": "قلم",
      "eraser": "ممحاة",
      "redo": "إعادة",
      "zoom": "الرسم بحجم مكبَّر",
      "zoomClose": "إغلاق العرض المكبَّر",
      "penWidth": "سُمك القلم {{width}}"
    }
  }
}
